import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import { Table } from 'components/table/table';

import { useTableHook } from './register-hooks';
import { registerColumns } from './register-columns';
import { GridCentralPanelProps } from './register-types';
import { RegisterDetail } from './register-detail';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: 'calc(100vh - 140px)',
    padding: theme.spacing(1),
  },
  paper: {
    height: 'calc(100vh - 172px)',
    padding: theme.spacing(1),
  },
  tableContainer: { height: 'calc(100vh - 275px)' },
}));

export function GridCentralPanel({
  detail,
  detailId,
  handleDetailId,
}: GridCentralPanelProps) {
  const classes = useStyles();
  const tableProps = useTableHook();

  return (
    <div className={classes.root}>
      <Paper elevation={0} className={classes.paper}>
        <Table
          {...tableProps}
          columns={registerColumns}
          expandableRows={true}
          classes={{ tableContainer: classes.tableContainer }}
          expanded={!!detailId ? [detailId] : []}
          setExpanded={handleDetailId}
          AdditionalRowComponent={RegisterDetail({ detail })}
        />
      </Paper>
    </div>
  );
}
